import { PortfolioRepo as portfolioRepo } from '@services/portfolio.repo';
import { PortfolioUtilities as portfolioUtilities } from '@common/portfolio.utilities';
import { portfolioSelectorService } from '../../portfolioSelector';
import * as echarts from 'echarts'

class PortfolioInternationalFixedIncomeController implements angular.IOnInit {

  chartFixedIncomeHeight: any;
  public fixedIncomeItems: any;
  public fixedIncomeTotal: any = 0;
  public selectedCurrency: string;

  public fixedIncomePieChart : any;
  public fixedIncomePieChartOptions : any;
  public fixedIncomePieChartData : any;

  /** @ngInject */
  constructor(private portfolioRepo: portfolioRepo, private portfolioUtilities: portfolioUtilities, private portfolioSelectorService : portfolioSelectorService,
              private $timeout: ng.ITimeoutService, $scope: angular.IScope, private notifyjs) {

    var that = this;

    this.portfolioSelectorService.registerCallback('portfolio.international.fixedincome', () => { this.updateData() }); // Need to wrap it in a fat arrow functiom to get the correctly scoped this

  }

  $onInit() {
    this.updateData();
  }

  public formatCurrency(currencyCode: string) {
    if(!this.portfolioSelectorService.isLoading){
      return this.portfolioUtilities.formatCurrency(currencyCode);
    }else{
      return "";
    }    
  }

  getFixedIncomePercentage(fixedIncome: any) {
    return (fixedIncome.marketValueDisplayCurrency / this.fixedIncomeTotal) * 100;
  }

  public scrollToElement(elementId: string) {
    var that = this;
    this.$timeout(function () { that.portfolioUtilities.scrollToElement(elementId); }, 220);
  }
  public initialisePieChart () {
    // need to put the initialisation of the pie chart in a function because the dom element is not available till 
    // the time you have clicked on the pie chart tab.
    var that = this;
    that.fixedIncomePieChart = echarts.init(document.getElementById('fixed-income-pie-chart'));
    that.fixedIncomePieChartOptions = {
      tooltip: {
        trigger: 'item',
        formatter: "{b} : {d}%"
      },
      color : ['#2a8fbe', '#54a5cb','#7fbbd8'],
      series: {
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '50%'],
        labelLine: {
          normal: {
            show: true
          }
        },
        data: that.fixedIncomePieChartData
      }
      
    }
    that.fixedIncomePieChart.setOption(that.fixedIncomePieChartOptions); 

  }

  updateData() {
    let that = this;
    this.portfolioSelectorService.setIsLoading(true);
    // Fixed Income data
    this.selectedCurrency = this.portfolioSelectorService.getSelectedCurrency()
    that.portfolioRepo.getPortfolioFixedIncomeItems(this.selectedCurrency, 'INTERNATIONAL', this.portfolioSelectorService.getSelectedPortfolios())
      .then((val) => {
        that.fixedIncomeItems = val.data;
        that.scrollToElement('fixedIncome');

        
        that.fixedIncomePieChartData = new Array();
        for (var s of that.fixedIncomeItems) {
          this.fixedIncomeTotal += s.marketValueDisplayCurrency;

          that.fixedIncomePieChartData.push({
            name : s.fixedIncomeItem.name,
            value : s.marketValueDisplayCurrency
          });

        }
        this.portfolioSelectorService.setIsLoading(false);
      })
      .catch( (err) => {
        this.portfolioSelectorService.setIsLoading(false);
        this.notifyjs("The fixed income data for the selected portfolios could not be loaded. Please try again later or contact the System Administrator.", "error");
      })
  }
}

export const portfolioInternationalFixedIncome: angular.IComponentOptions = {
  template: require('../portfolio.international.fixedincome/portfolio.international.fixedincome.html'),
  controller: PortfolioInternationalFixedIncomeController
}



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio.international/portfolio.international.fixedincome/portfolio.international.fixedincome.ts